import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import {InteractiveHero} from "./InteractiveHero";
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {ArticleTitle, ExternalLink, InsetColumn, PageSection} = _components;
  if (!ArticleTitle) _missingMdxReference("ArticleTitle", true);
  if (!ExternalLink) _missingMdxReference("ExternalLink", true);
  if (!InsetColumn) _missingMdxReference("InsetColumn", true);
  if (!PageSection) _missingMdxReference("PageSection", true);
  return _jsxs(_Fragment, {
    children: [_jsx(InteractiveHero, {}), "\n", _jsx(ArticleTitle, {
      title: "By Design?",
      subtitle: "How Design Harms and Confuses Consumers in Digital, Finance Products",
      author: "written and researched by Caroline Sinders, co-founder of Convocation Research + Design",
      published: "published October 12, 2025"
    }), "\n", _jsx(PageSection, {
      backgroundStyle: "transparent",
      children: _jsxs(InsetColumn, {
        children: [_jsxs(_components.p, {
          children: ["Have you ever thought you’ve unsubscribed from an email but found you're still subscribed? Or canceled a subscription but still got charged? Or, perhaps, you are shopping online and thought you selected one item, only to find that a smaller item was added automatically to the bag, too. All of these examples are a part of a specific design phenomena called ‘harmful design patterns.’ ", _jsx(ExternalLink, {
            href: "https://www.drcf.org.uk/siteassets/drcf/pdf-files/harmful-design-in-digital-markets-ico-cma-joint-position-paper.pdf?v=380506",
            children: "Harmful design patterns"
          }), ", often referred to as ", _jsx(ExternalLink, {
            href: "https://arxiv.org/pdf/2101.04843",
            children: "dark patterns"
          }), ", ", _jsx(ExternalLink, {
            href: "https://www.deceptive.design",
            children: "deceptive design patterns"
          }), ", ", _jsx(ExternalLink, {
            href: "https://500.co/content/anti-patterns-when-design-gets-deceptive",
            children: "anti-patterns"
          }), ", ", _jsx(ExternalLink, {
            href: "https://www.bitsoffreedom.nl/wp-content/uploads/2025/06/20250616-report-exploratory_study_manipulative_design.pdf",
            children: "manipulative design patterns"
          }), ", ", _jsx(ExternalLink, {
            href: "https://assets.publishing.service.gov.uk/media/624c27c68fa8f527710aaf58/Online_choice_architecture_discussion_paper.pdf",
            children: "online choice architecture"
          }), ", are ", _jsx(ExternalLink, {
            href: "https://www.interaction-design.org/literature/topics/ui-design-patterns#:~:text=User%20interface%20(UI)%20design%20patterns%20are%20reusable/recurring%20components,the%20specific%20context%20of%20use",
            children: "design patterns"
          }), " that unintentionally or intentionally trick, manipulate, nudge, confuse or direct a consumer to make a decision they did not intend to make, and often that decision benefits the company, and not the consumer. ", _jsx(ExternalLink, {
            href: "https://op.europa.eu/en/publication-detail/-/publication/606365bc-d58b-11ec-a95f-01aa75ed71a1/language-en",
            children: "Harmful design patterns are prevalent across the internet"
          }), ", and across all different types of products, domains, websites and shops. They can be found anywhere and in any language, geography and region. But, the majority of academic and civil society research tends to focus on e-commerce and privacy related harmful design patterns."]
        }), _jsxs(_components.p, {
          children: ["With financial support from the ", _jsx(ExternalLink, {
            href: "https://interledger.org",
            children: "Interledger Foundation"
          }), " in their 2025 ambassadorship cohort, I spent 8 months conducting a broad literature review, systemic mapping of the ecosystem, design analysis and light weight user interviews focusing on harmful design pattern, confusion, friction and barriers in financial service platforms, while also analysing how does design impact digital financial inclusion. In this project, I observed four users who are creatives and freelancer immigrants in the UK and who send money back home to South America, while also sending and receiving money across the UK, Europe and Asia as a part of their freelance practices. Additionally, I spoke to former and current regulators in the US and the UK, I interviewed financial experts, harmful design patterns experts, and users of different traditional banks, neo-banks, and financial service platforms in an effort to map out and understand the emergent landscape of harmful design patterns in the financial services space, and design’s impact on digital financial inclusion."]
        })]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
